import React, { Component } from "react";
import { useState, useEffect } from 'react'
import store from "@/redux/store";
import {showVideo, hideModal} from "@/reducers/ModalPopup";    


import { BuildingOfficeIcon, CreditCardIcon, UserIcon, UsersIcon } from '@heroicons/react/20/solid'

import { Profile } from "@/views/base/user/Profile";
import { Interest } from "@/views/base/user/Interest";
import {getUserInterests, getUserExperience} from "@/reducers/User";
import {getUserDocuments} from "@/reducers/Document";
import { Settings } from "../base/user/Settings";
import { DocumentOverview } from "@/views/base/documents/Overview";

import { useNavigate, Link } from "react-router-dom";
import { useForm, SubmitHandler, Controller } from "react-hook-form"

import {BaseForm} from "@/views/base/BaseForm";
import { Experience } from "../base/user/Experience";

export function Detail({...props}) {
    const [selectedTab, setSelectedTab] = useState(1)
      const { register, handleSubmit, watch, reset, control, setValue, getValues, formState, formState: { isSubmitSuccessful } } = useForm({
      defaultValues: props.data
    })

    let user = getValues();

const tabs = [
  {tabId: 1, name: 'Mijn gegevens', href: '#', icon: UserIcon, current: true },
  {tabId: 4, name: 'Mijn documenten', href: '#', icon: UserIcon, current: true },
  {tabId: 2, name: 'Interesses', href: '#', icon: UserIcon, current: false },
  {tabId: 5, name: 'Ervaringen', href: '#', icon: UserIcon, current: false },
  {tabId: 3, name: 'Beheer', href: '#', icon: UserIcon, current: false },
]  // More people...
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const showVideo1 = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    store.dispatch( showVideo({}) );
    return false;
    };

const setTab = (tabId) => {
    if(tabId == 2) {
    store.dispatch( getUserInterests()).then((value) => {
        });
        }
    if(tabId == 5) {
    store.dispatch( getUserExperience()).then((value) => {
        });
        }
    if(tabId == 4) {
    store.dispatch( getUserDocuments()).then((value) => {
        });
        }
        
    setSelectedTab(tabId);
    }
    
  const onSaveWrapped = (data) => {
    event.preventDefault();
    event.stopPropagation();
    
    props.onSaveHandler(data);
      
    return false;
  };

console.log("PPPP", props )
      return (
    <>


    <div className="px-4 sm:px-6 lg:px-8">
    <button onClick={(event) => showVideo1(event)}>Help video</button>
    
    <div>
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.current).name}
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav id="myProfileTab" aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                id={'tabId'+tab.tabId}
                key={tab.name}
                href={tab.href}
                onClick={() => setTab(tab.tabId)}
                aria-current={tab.tabId == selectedTab ? 'page' : undefined}
                className={classNames(
                  tab.tabId == selectedTab
                    ? 'border-indigo-500 text-indigo-600'
                    : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                  'group inline-flex items-center border-b-2 px-1 py-4 text-sm font-medium',
                )}
              >
                <span>{tab.name}</span>
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
    
    <BaseForm onSaveHandler={onSaveWrapped} data={props.data} key={selectedTab}>
        {selectedTab == 1 &&
        <Profile {...props} key="Profile" id="myprofile" state={props}/>
        }
        
    </BaseForm>   
     
        {selectedTab == 4 &&
            <DocumentOverview key={props?.changeKey} data={ {key:props?.data?.key} } withSharing={true} isTeam={false} onSaveHandler={onSaveWrapped} state={props?.error} documents={props?.userDocuments} tenants={props?.data?.tenant}/>
        }
        {selectedTab == 2 &&
        <Interest {...props} interests={props.interests} key={props.changeKey}/>
        }
        {selectedTab == 5 &&
        <Experience {...props} experience={props.experience} key={props.changeKey}/>
        }
        {selectedTab == 3 &&
            <Settings key={props?.changeKey} data={ {key:props?.data?.key} } onSaveHandler={onSaveWrapped} state={props?.error}/>
        }
{ tabs.length == 9999 &&    
    <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2" onSubmit={handleSubmit(onSaveWrapped)}>
          <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>
    
    
    {selectedTab == 1 &&
    <Profile {...props} key="Profile" id="myprofile" />
    }
    {selectedTab == 2 &&
    <Interest {...props} interests={props.interests} key={props.changeKey}/>
    }
    {selectedTab == 5 &&
    <Experience {...props} interests={props.interests} key={props.changeKey}/>
    }
    {selectedTab == 3 &&
        <Settings key={props?.changeKey} data={ {key:props?.data?.key} } onSaveHandler={onSaveWrapped} state={props?.error}/>
    }
    {selectedTab == 4 &&
        <DocumentOverview key={props?.changeKey} data={ {key:props?.data?.key} } withSharing={true} isTeam={false} onSaveHandler={onSaveWrapped} state={props?.error} documents={props?.userDocuments} tenants={props?.data?.tenant}/>
    }
        </form>
        }
    </div>


    </>
    );
  }
